import { LineProgressBar } from '@/features/progress-bar';
interface Props {
  originalIndex: number;
  originalLength: number;
}
const SliderProgressBar = ({
  originalIndex,
  originalLength
}: Props) => {
  return <LineProgressBar percent={(originalIndex + 1) * 100 / (originalLength || 1)} mainBarclassName='h-0.5 lg:h-1 bg-gray-200' activeBarClassName='h-0.5 lg:h-1 bg-black' className='order-3 mt-5 flex-col-reverse px-2 lg:order-1 lg:mb-10 lg:mt-0 lg:px-0' data-sentry-element="LineProgressBar" data-sentry-component="SliderProgressBar" data-sentry-source-file="slider-progress-bar.tsx">
            <div className='mb-1 flex w-full items-center justify-center gap-1 text-caption-12 font-bold lg:text-base lg:font-medium'>
                <span className='text-text-darkGray'>{originalLength} /</span>
                <span> {originalIndex + 1}</span>
            </div>
        </LineProgressBar>;
};
export default SliderProgressBar;